<template>
  <v-container fluid class="pa-0">
    <!--app-bar-->
    <v-app-bar flat color="red-darken-3" class="pt-1 pb-1">
      <!--Title-->
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("shipments.label") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
      <!--Search-->
      <v-text-field
        v-model="search"
        :label="$t('shipments.search')"
        flat
        variant="solo"
        color="red-darken-1"
        append-inner-icon="mdi-magnify"
        single-line
        hide-details
        class="ml-1"
      />
      <v-col
        v-if="
          !searchById &&
          ($store.getters.role === 'LekoAdmin' ||
            $store.getters.role === 'SuperAdmin')
        "
        xs="12"
        :sm="
          $store.getters.role === 'LekoAdmin' ||
          $store.getters.role === 'SuperAdmin'
            ? '4'
            : '1'
        "
        :xl="
          $store.getters.role === 'LekoAdmin' ||
          $store.getters.role === 'SuperAdmin'
            ? '2'
            : '1'
        "
      >
        <v-autocomplete
          v-model="institution"
          :items="institutions"
          :loading="loadingInstitution"
          :label="$t('parts.advanced_search.institution')"
          item-title="title"
          item-value="_id"
          flat
          variant="solo"
          color="red-darken-1"
          class="ml-2 mr-2"
          clearable
          hide-details
          @click:clear="clearSearch"
        />
      </v-col>
      <v-btn
        v-if="
          $store.getters.role === 'LekoAdmin' ||
          $store.getters.role === 'SuperAdmin'
        "
        small
        @click="searchById = !searchById"
      >
        <v-icon start>
          {{
            searchById ? "mdi-checkbox-outline" : "mdi-checkbox-blank-outline"
          }}
        </v-icon>
        {{ $t("parts.insert_parts.id_only") }}
      </v-btn>
      <v-spacer />
      <!-- Delete Shipments -->
      <v-btn
        v-if="selected.length > 0"
        color="grey-darken-4"
        variant="flat"
        :disabled="selected.find((s) => s.vehicle)"
        :loading="loadingDelete"
        class="mx-1"
        @click="deleteShipments"
      >
        {{ $t("shipments.delete") }}
        <v-icon end>mdi-delete</v-icon>
      </v-btn>
      <!--Print Shipments-->
      <v-btn
        color="grey-darken-4"
        class="mx-1 hidden-sm-and-down"
        variant="flat"
        @click="printShipments"
      >
        {{ $t("shipments.print") }}
        <v-icon end>mdi-printer</v-icon>
      </v-btn>
      <!--New Shipment-->
      <v-btn
        v-if="
          $store.getters.role == 'LekoAdmin' ||
          $store.getters.role == 'InstitutionAdmin' ||
          $store.getters.role == 'InstitutionManager' ||
          $store.getters.role == 'SuperAdmin'
        "
        color="grey-darken-4"
        variant="flat"
        class="mx-1"
        @click="newShipment"
      >
        {{ $t("shipments.button") }}
        <v-icon end>mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>
    <!--ALERT-->
    <v-alert
      :model-value="alert.value"
      type="error"
      variant="tonal"
      border="bottom"
    >
      {{ alert.message }}
    </v-alert>
    <!--QR DIALOG-->
    <qr-dialog ref="qrDialog" />
    <!--DIALOG-->
    <edit-dialog ref="dialog" @save="getShipments" @error="showAlert" />
    <!--INSERT EMPTY-->
    <insert-empty ref="insertEmpty" />
    <!--DATATABLE-->
    <datatable
      ref="datatable"
      :search="search"
      :search-by-id="searchById"
      :institution="institution"
      @qr="openQrDialog"
      @insert="openInsertDialog"
      @edit-shipment="editShipment"
      @error="showAlert"
      @selected="setSelectedItems"
    />
    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert class="mb-0" :value="true" type="error">
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Datatable from "@/components/Shipments/datatable.vue";
import Dialog from "@/components/Shipments/dialog.vue";
import QrDialog from "@/components/qrDialog.vue";
import InsertEmpty from "@/components/Shipments/insertEmpty.vue";
import Print from "../components/Shipments/print";
import getRequest from "../api/getRequest";
import deleteRequest from "../api/deleteRequest";

export default {
  components: {
    datatable: Datatable,
    "insert-empty": InsertEmpty,
    "edit-dialog": Dialog,
    "qr-dialog": QrDialog,
  },
  data: () => ({
    search: "",
    selected: [],
    loadingDelete: false,
    alert: {
      value: false,
      message: String,
    },
    institution: "",
    institutions: [],
    loadingInstitution: false,
    searchById: false,
    dialogDelete: false,
  }),
  watch: {},
  mounted() {
    this.getShipments();
    if (
      this.$store.getters.role === "LekoAdmin" ||
      this.$store.getters.role === "SuperAdmin"
    ) {
      this.getInstitutions();
    }
  },
  methods: {
    showAlert(error) {
      this.alert = {
        value: true,
        message: "",
      };
      setTimeout(() => {
        this.alert.value = false;
      }, 2000);
    },
    openInsertDialog(shipmentId) {
      const { insertEmpty } = this.$refs;
      insertEmpty.open(shipmentId);
    },
    getShipments() {
      const { datatable } = this.$refs;
      datatable.getShipments();
    },
    printShipments() {
      const { datatable } = this.$refs;
      Print(datatable.shipments);
    },
    newShipment() {
      const { dialog } = this.$refs;
      dialog.open(false, null);
    },
    editShipment(shipment) {
      const { dialog } = this.$refs;
      dialog.open(true, shipment);
    },
    openQrDialog(data) {
      const { qrDialog } = this.$refs;
      qrDialog.open(data);
    },
    setSelectedItems(data) {
      this.selected = data;
    },
    deleteShipments() {
      this.dialogDelete = true;
    },
    confirmDelete() {
      this.loadingDelete = true;
      const ids = this.selected.map((s) => s._id).join(",");
      deleteRequest("/shipment/", `ids=${ids}`)
        .then((response) => {
          if (response) {
            this.deleteDialog = false;
            this.getShipments();
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loadingDelete = false;
          this.deleteDialog = false;
        });
    },
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
          this.loadingInstitution = false;
        })
        .catch(() => {
          this.loadingInstitution = false;
        });
    },
    clearSearch() {
      // this.search = '';
      this.institution = "";
    },
  },
};
</script>
<style>
.v-app-bar-title__content {
  flex: 1 1 auto !important;
  min-width: 0;
}
</style>
